import {Button, Paper, Typography, Box, IconButton, Tooltip, Divider, Chip} from '@mui/material';
import {
  ArrowForward, 
  CheckCircle, 
  Pause, 
  PlayArrow, 
  Timer, 
  Add, 
  Remove,
  SkipNext,
  Info
} from '@mui/icons-material';

const GameMasterControls = ({ 
  allPlayersAnswered,
  onNextQuestion,
  isLastQuestion,
  timeLeft,
  showAnswers,
  onPauseGame,
  onResumeGame,
  onAddTime,
  onReduceTime,
  isPaused = false
}) => {
  return (
    <Paper 
      className="glass"
      sx={{ 
        p: 2, 
        mt: 2,
        background: 'rgba(23, 42, 69, 0.4)',
        backdropFilter: 'blur(10px)',
        borderColor: 'rgba(255, 255, 255, 0.1)'
      }}
    >
      <Typography 
        variant="h6" 
        gutterBottom
        sx={{
          fontWeight: 'bold',
          color: 'var(--color-secondary)',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}
      >
        <Info fontSize="small" /> Game Master Steuerung
      </Typography>

      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ mb: 1, opacity: 0.8 }}>
          Spielstatus: {showAnswers ? 'Antworten werden angezeigt' : 'Frage läuft'}
          {isPaused && ' (Pausiert)'}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <Chip 
            icon={<Timer fontSize="small" />} 
            label={`Zeit: ${timeLeft}s`} 
            color="primary" 
            size="small"
            sx={{ 
              background: timeLeft < 10 ? 'rgba(211, 47, 47, 0.7)' : 'rgba(25, 118, 210, 0.7)',
              backdropFilter: 'blur(5px)'
            }}
          />
          
          <Chip 
            label={allPlayersAnswered ? 'Alle haben geantwortet' : 'Warte auf Antworten'} 
            color={allPlayersAnswered ? "success" : "default"} 
            size="small"
            sx={{ 
              background: allPlayersAnswered ? 'rgba(46, 125, 50, 0.7)' : 'rgba(66, 66, 66, 0.7)',
              backdropFilter: 'blur(5px)'
            }}
          />
        </Box>
      </Box>

      <Divider sx={{ my: 1.5, borderColor: 'rgba(255, 255, 255, 0.1)' }} />
      
      <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
        <Tooltip title={isPaused ? "Spiel fortsetzen" : "Spiel pausieren"}>
          <IconButton 
            onClick={isPaused ? onResumeGame : onPauseGame}
            sx={{ 
              background: 'rgba(0, 0, 0, 0.2)',
              '&:hover': { background: 'rgba(0, 0, 0, 0.3)' }
            }}
          >
            {isPaused ? <PlayArrow /> : <Pause />}
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Zeit hinzufügen (+10s)">
          <IconButton 
            onClick={() => onAddTime(10)}
            sx={{ 
              background: 'rgba(0, 0, 0, 0.2)',
              '&:hover': { background: 'rgba(0, 0, 0, 0.3)' }
            }}
          >
            <Add />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Zeit reduzieren (-10s)">
          <IconButton 
            onClick={() => onReduceTime(10)}
            disabled={timeLeft < 11}
            sx={{ 
              background: 'rgba(0, 0, 0, 0.2)',
              '&:hover': { background: 'rgba(0, 0, 0, 0.3)' },
              '&.Mui-disabled': { 
                background: 'rgba(0, 0, 0, 0.1)',
                opacity: 0.5
              }
            }}
          >
            <Remove />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Sofort zur nächsten Frage">
          <span>
            <IconButton 
              onClick={onNextQuestion}
              disabled={isLastQuestion}
              sx={{ 
                background: 'rgba(0, 0, 0, 0.2)',
                '&:hover': { background: 'rgba(0, 0, 0, 0.3)' },
                '&.Mui-disabled': { 
                  background: 'rgba(0, 0, 0, 0.1)',
                  opacity: 0.5
                }
              }}
            >
              <SkipNext />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      
      <Button
        fullWidth
        variant="contained"
        onClick={onNextQuestion}
        disabled={!allPlayersAnswered && !showAnswers}
        className="button-glow"
        sx={{
          background: isLastQuestion ? 
            'linear-gradient(45deg, #2e7d32 30%, #43a047 90%)' : 
            'var(--color-secondary)',
          color: 'var(--color-text-primary)',
          fontWeight: 'bold',
          textShadow: '0 1px 2px rgba(0,0,0,0.3)',
          height: '50px',
          fontSize: '1.1rem',
          '&:hover': {
            background: isLastQuestion ? 
              'linear-gradient(45deg, #1b5e20 30%, #2e7d32 90%)' : 
              'var(--color-secondary-light)'
          },
          '&.Mui-disabled': {
            background: 'rgba(255, 255, 255, 0.12)',
            color: 'var(--color-text-disabled)'
          }
        }}
        endIcon={isLastQuestion ? <CheckCircle /> : <ArrowForward />}
      >
        {isLastQuestion ? 'Ergebnis ansehen' : 'Nächste Frage'}
      </Button>
    </Paper>
  );
};

export default GameMasterControls; 